import { Badge } from "@/components/ui/badge";

import { MetaLeadsEventsTableActions } from "routes/meta_leads_events/MetaLeadsEventsTableActions";

const NameCell = ({ event }) => (
  <span className="tw:inline-flex tw:items-center tw:gap-1.5">
    {event.color && (
      <span
        className="tw:inline-block tw:size-2 tw:rounded-full"
        style={{ backgroundColor: event.color }}
      />
    )}
    {event.name}
  </span>
);

export const getMetaLeadsEventsTableColumns = () => {
  return [
    {
      header: "ID",
      id: "ID",
      accessorKey: "id",
      size: 60,
      cell: ({ row }) => (
        <p style={{ fontWeight: "bold" }}>{row.original.id}</p>
      ),
    },
    {
      header: "Name",
      id: "Name",
      accessorKey: "name",
      size: 250,
      cell: ({ row }) => <NameCell event={row.original} />,
    },
    {
      header: "Meta Event Name",
      id: "Meta Event Name",
      accessorKey: "event_name",
      enableSorting: false,
      cell: ({ row }) => row.original?.event_name || "--",
    },
    {
      header: "Reports to Meta",
      id: "Reports to Meta",
      accessorKey: "reports_to_meta",
      cell: ({ row }) => (
        <Badge variant={row.original?.reports_to_meta ? "default" : "outline"}>
          {row.original?.reports_to_meta ? "Yes" : "No"}
        </Badge>
      ),
    },
    {
      header: null,
      id: "Actions",
      accessorKey: "actions",
      enableSorting: false,
      enableResizing: false,
      size: 60,
      meta: {
        isDisplay: true,
      },
      cell: ({ row }) => (
        <MetaLeadsEventsTableActions original={row.original} />
      ),
    },
  ];
};

export const getMetaLeadsEventsTableFilters = () => {
  return [
    {
      key: "reports_to_meta",
      title: "Reports to Meta",
      type: "select",
      data: [
        { id: true, name: "Yes" },
        { id: false, name: "No" },
      ],
    },
  ];
};
